import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const Loading = ({
                     fullScreen = false,
                     minDuration = 3000,
                     onComplete
                 }) => {
    const [isVisible, setIsVisible] = useState(true);

    // Styles pour le conteneur principal du loading
    const containerStyle = {
        position: fullScreen ? "fixed" : "relative",
        top: fullScreen ? 0 : "auto",
        left: fullScreen ? 0 : "auto",
        width: fullScreen ? "100%" : "auto",
        height: fullScreen ? "100%" : "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: fullScreen ? "rgba(0, 0, 0, 0.3)" : "transparent",
        zIndex: 9999,
        backdropFilter: fullScreen ? "blur(5px)" : "none",
    };

    // Styles pour l'animation des bâtonnets
    const createBarStyle = (delay) => ({
        width: "8px",
        height: "40px",
        margin: "0 4px",
        backgroundColor: "#3498db",
        borderRadius: "4px",
        animation: "loading 1.2s infinite",
        animationDelay: `${delay}s`,
        transformOrigin: "center",
    });

    // Keyframes pour l'animation
    const keyframesStyle = `
        @keyframes loading {
            0%, 40%, 100% {
                transform: scaleY(0.4);
                opacity: 0.3;
            }
            20% {
                transform: scaleY(1);
                opacity: 1;
            }
        }
    `;

    // Gestion du temps minimal de chargement
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            if (onComplete) onComplete();
        }, minDuration);

        return () => clearTimeout(timer);
    }, [minDuration, onComplete]);

    // Si le chargement n'est plus visible, ne rien afficher
    if (!isVisible) return null;

    return (
        <>
            {/* Injection des keyframes */}
            <style>{keyframesStyle}</style>

            <div style={containerStyle}>
                <div style={{ display: "flex" }}>
                    {[0, 0.2, 0.4, 0.6, 0.8].map((delay, index) => (
                        <div
                            key={index}
                            style={createBarStyle(delay)}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

Loading.propTypes = {
    fullScreen: PropTypes.bool,
    minDuration: PropTypes.number,
    onComplete: PropTypes.func,
};

export default Loading;